var noCase = require('no-case')

/**
 * Snake case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '_')
}



//////////////////
// WEBPACK FOOTER
// ./~/snake-case/snake-case.js
// module id = 522
// module chunks = 0